import { useEffect, useMemo, useState } from 'react'

import type { Locale } from '~/common/@types'

import { getMessages } from './services'

export const useMessages = (language?: Locale) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<Error>()
  const [data, setData] = useState<Record<string, string>>()

  const loaded = useMemo(() => {
    return !!data
  }, [data])

  useEffect(() => {
    if (!language) return

    setLoading(true)

    getMessages(language)
      .then(setData)
      .catch(setError)
      .finally(() => {
        setLoading(false)
      })
  }, [language])

  return {
    loading,
    loaded,
    error,
    data,
  }
}
